import type { AppMessages } from "@/i18n/ja";
import { createList } from "./createList";

interface ResetHelpSubsectionMessages {
  readonly heading: string;
  readonly description: string;
  readonly items: readonly string[];
  readonly resetHeading: string;
  readonly resetItems: readonly string[];
  readonly keepHeading: string;
  readonly keepItems: readonly string[];
  readonly warning: string;
}

export function renderHovPanel(
  container: HTMLElement,
  messages: AppMessages,
  options: {
    readonly isMHovUnlocked: boolean;
    readonly isNHovUnlocked: boolean;
  },
): void {
  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = messages.help.hov.description;

  const list = document.createElement("ul");
  list.className = "hover-idle-help-list";
  for (const item of messages.help.hov.items) {
    const listItem = document.createElement("li");
    listItem.textContent = item;
    list.append(listItem);
  }

  const resetSections = [
    ...(options.isMHovUnlocked
      ? [createResetHelpSubsection(messages.help.hov.mHov)]
      : []),
    ...(options.isNHovUnlocked
      ? [createResetHelpSubsection(messages.help.hov.nHov)]
      : []),
  ];

  container.replaceChildren(description, list, ...resetSections);
}

function createResetHelpSubsection(
  messages: ResetHelpSubsectionMessages,
): HTMLElement {
  const section = document.createElement("section");
  section.className = "hover-idle-help-subsection";

  const heading = document.createElement("h3");
  heading.className = "hover-idle-help-subtitle";
  heading.textContent = messages.heading;

  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = messages.description;

  const warning = document.createElement("p");
  warning.className = "hover-idle-help-warning";
  warning.textContent = messages.warning;

  section.append(
    heading,
    description,
    createList(messages.items),
    createHelpGroup(messages.resetHeading, messages.resetItems),
    createHelpGroup(messages.keepHeading, messages.keepItems),
    warning,
  );
  return section;
}

function createHelpGroup(
  heading: string,
  items: readonly string[],
): HTMLElement {
  const group = document.createElement("div");
  group.className = "hover-idle-help-group";

  const title = document.createElement("h4");
  title.className = "hover-idle-help-group-title";
  title.textContent = heading;

  group.append(title, createList(items));
  return group;
}
